import Icon from "./Icon";

export default function Dropdown({
  text,
  icon,
  className,
  classNameBtn,
  classNameMenu,
  target,
  children,
}) {
  return (
    <div className={className + " dropdown"}>
      <button
        type="button"
        data-bs-toggle="dropdown"
        data-bs-target={"#" + target}
        className={classNameBtn + " dropdown-toggle"}>
        {icon && <Icon name={icon} className="me-1" />}
        {text}
      </button>
      <div className={classNameMenu + " dropdown-menu"} id={target}>
        {children}
      </div>
    </div>
  );
}
